<template>
	<div class="container">
		<div class="content">
			<div class="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item replace :to="{ path: '/my/index' }">个人中心</el-breadcrumb-item>
					<el-breadcrumb-item>上级团队</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<!-- 上级团队信息 -->
			<div class="superior-info" v-if="data.superior_info">
				<div class="superior-card">
					<div class="superior-header">
						<div class="superior-avatar">
							<el-avatar :size="60" :src="$img(data.superior_info.avatar)"/>
						</div>
						<div class="superior-details">
							<div class="superior-name">{{ data.superior_info.nickname || '未设置昵称' }}</div>
							<div class="superior-phone">{{ data.superior_info.phone || '未设置手机号' }}</div>
							<div class="superior-role">团队队长</div>
						</div>
					</div>
				</div>
			</div>

			<div class="team-overview">
				<div class="overview-card">
					<div class="overview-header">
						<div class="overview-icon">
							<i class="el-icon-s-custom"></i>
						</div>
						<div>
							<div class="overview-title">团队成员</div>
							<div class="overview-value">{{ data.user_count || 0 }}</div>
						</div>
					</div>
				</div>

				<div class="overview-card">
					<div class="overview-header">
						<div class="overview-icon">
							<i class="el-icon-s-order"></i>
						</div>
						<div>
							<div class="overview-title">总出单数</div>
							<div class="overview-value">{{ data.order_count || 0 }}</div>
						</div>
					</div>
				</div>

				<div class="overview-card">
					<div class="overview-header">
						<div class="overview-icon">
							<i class="el-icon-s-finance"></i>
						</div>
						<div>
							<div class="overview-title">总保费金额</div>
							<div class="overview-value">¥{{ formatAmount(data.total_amount || 0) }}</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 时间筛选 -->
			<div class="filter-section">
				<div class="filter-title">
					<i class="el-icon-menu"></i>
					选择时间范围
				</div>
				<div class="date-range-selector">
					<el-date-picker 
						v-model="dateRange"
						type="datetimerange" 
						range-separator="至" 
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd HH:mm:ss"
						:default-time="['00:00:00', '23:59:59']">
					</el-date-picker>
				</div>
				<div class="filter-actions">
					<button class="btn btn-primary" @click="handleFilter">
						<i class="el-icon-check"></i>
						应用筛选
					</button>
					<button class="btn btn-secondary" @click="handleReset">
						<i class="el-icon-refresh-right"></i>
						重置
					</button>
				</div>
			</div>

			<!-- 成员列表 -->
			<div class="member-list">
				<div class="list-header">
					<div class="list-title">
						<i class="el-icon-s-cooperation"></i>
						团队成员业绩
					</div>
					<div class="list-total">共 {{ data.list ? data.list.length : 0 }} 位成员</div>
				</div>

				<div v-if="loading" class="loading-container">
					<i class="el-icon-loading"></i>
					加载中...
				</div>

				<template v-else>
					<table v-if="data.list && data.list.length > 0" class="member-table">
						<thead>
							<tr>
								<th>团队成员</th>
								<th>出单数</th>
								<th>保费金额</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in data.list" :key="index">
								<td>
									<div class="member-info">
										<div class="member-avatar">
											<el-avatar :size="40" :src="$img(item.avatar)"/>
										</div>
										<div class="member-details">
											<div class="name">{{ item.nickname || '未设置昵称' }}</div>
											<div class="phone">{{ item.phone || '未设置手机号' }}</div>
										</div>
									</div>
								</td>
								<td>
									<span class="order-count">{{ item.order_count || 0 }}</span>
								</td>
								<td>
									<span class="amount">¥{{ formatAmount(item.total_amount || 0) }}</span>
								</td>
							</tr>
						</tbody>
					</table>
					
					<div v-else class="empty-state">
						<i class="el-icon-s-custom"></i>
						<div class="empty-text">暂无团队成员</div>
						<div class="empty-desc">当前团队还没有其他成员</div>
					</div>
				</template>
			</div>
		</div>
		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	export default {
		components: {
			mainFooter,
		},
		data() {
			return {
				dateRange: [],
				form: {
					startTime: '',
					endTime: '',
				},
				data: {
					superior_info: {}, // 上级信息
					list: [],
					user_count: 0,
					order_count: 0,
					total_amount: 0,
				},
				loading: false,
			}
		},
		mounted() {
			this.ActionList();
		},
		methods: {
			// 格式化金额
			formatAmount(amount) {
				return parseFloat(amount).toFixed(2);
			},
			
			// 处理筛选
			handleFilter() {
				if (this.dateRange && this.dateRange.length === 2) {
					this.form.startTime = this.dateRange[0];
					this.form.endTime = this.dateRange[1];
				} else {
					this.form.startTime = '';
					this.form.endTime = '';
				}
				this.ActionList();
			},
			
			// 重置筛选
			handleReset() {
				this.dateRange = [];
				this.form.startTime = '';
				this.form.endTime = '';
				this.ActionList();
			},
			
			// 获取列表数据
			ActionList(){
				this.loading = true;
				this.$load();
				this.$get('superiorTeamList', this.form, true).then(res => {
					this.data = res.data || {};
					this.loading = false;
				}).catch(err => {
					this.$warning(err);
					this.loading = false;
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;

		.content {
			min-height: calc(100vh - 300px);
			margin: 20px auto 40px;
			width: 68%;

			/* 上级团队信息 */
			.superior-info {
				margin-top: 20px;
				margin-bottom: 25px;
			}

			.superior-card {
				background: white;
				border-radius: 12px;
				padding: 25px;
				box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
				display: flex;
				justify-content: space-between;
				align-items: center;
			}

			.superior-header {
				display: flex;
				align-items: center;
				gap: 15px;
			}

			.superior-avatar {
				width: 60px;
				height: 60px;
			}

			.superior-details .superior-name {
				font-size: 20px;
				font-weight: 600;
				margin-bottom: 5px;
				color: #333;
			}

			.superior-details .superior-phone {
				font-size: 14px;
				color: #666;
				margin-bottom: 5px;
			}

			.superior-details .superior-role {
				font-size: 12px;
				color: #2280FD;
				background: rgba(34, 128, 253, 0.1);
				padding: 2px 8px;
				border-radius: 10px;
				display: inline-block;
			}

			.team-overview {
				margin-top: 20px;
				display: grid;
				grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
				gap: 20px;
				margin-bottom: 30px;
			}

			.overview-card {
				background: white;
				border-radius: 12px;
				padding: 25px;
				box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
				transition: transform 0.3s ease, box-shadow 0.3s ease;
			}

			.overview-card:hover {
				transform: translateY(-5px);
				box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
			}

			.overview-header {
				display: flex;
				align-items: center;
				margin-bottom: 15px;
			}

			.overview-icon {
				width: 50px;
				height: 50px;
				background: rgba(34, 128, 253, 0.1);
				color: #2280FD;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 24px;
				margin-right: 15px;
			}

			.overview-title {
				font-size: 16px;
				color: #666;
			}

			.overview-value {
				font-size: 28px;
				font-weight: 600;
				color: #333;
			}

			/* 时间筛选 */
			.filter-section {
				background: white;
				border-radius: 12px;
				padding: 25px;
				margin-bottom: 25px;
				box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
			}

			.filter-title {
				font-size: 18px;
				font-weight: 600;
				margin-bottom: 20px;
				color: #333;
				display: flex;
				align-items: center;
				gap: 10px;
			}

			.filter-title i {
				color: #2280FD;
			}

			.date-range-selector {
				display: flex;
				gap: 15px;
				align-items: center;
				flex-wrap: wrap;
			}

			.filter-actions {
				display: flex;
				gap: 10px;
				margin-top: 15px;
			}

			.btn {
				padding: 10px 20px;
				border: none;
				border-radius: 6px;
				font-size: 14px;
				font-weight: 500;
				cursor: pointer;
				transition: all 0.3s ease;
				display: flex;
				align-items: center;
				gap: 8px;
			}

			.btn-primary {
				background: #2280FD;
				color: white;
				box-shadow: 0 2px 8px rgba(34, 128, 253, 0.3);
			}

			.btn-primary:hover {
				background: #1a6fd0;
				transform: translateY(-2px);
				box-shadow: 0 4px 12px rgba(34, 128, 253, 0.4);
			}

			.btn-secondary {
				background: white;
				color: #2280FD;
				border: 1px solid #2280FD;
			}

			.btn-secondary:hover {
				background: rgba(34, 128, 253, 0.05);
			}

			/* 成员列表 */
			.member-list {
				background: white;
				border-radius: 12px;
				padding: 25px;
				box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
			}

			.list-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 20px;
			}

			.list-title {
				font-size: 18px;
				font-weight: 600;
				color: #333;
				display: flex;
				align-items: center;
				gap: 10px;
			}

			.list-title i {
				color: #2280FD;
			}

			.list-total {
				color: #666;
				font-size: 14px;
			}

			.member-table {
				width: 100%;
				border-collapse: collapse;
			}

			.member-table th {
				background: #f9fafb;
				padding: 15px;
				text-align: left;
				font-weight: 600;
				color: #333;
				border-bottom: 1px solid #e0e0e0;
			}

			.member-table td {
				padding: 15px;
				border-bottom: 1px solid #f0f0f0;
			}

			.member-table tr:hover {
				background: #f9fafb;
			}

			.member-info {
				display: flex;
				align-items: center;
				gap: 12px;
			}

			.member-avatar {
				width: 40px;
				height: 40px;
			}

			.member-details .name {
				font-weight: 500;
				margin-bottom: 3px;
			}

			.member-details .phone {
				font-size: 12px;
				color: #666;
			}

			.order-count {
				font-weight: 500;
				color: #2280FD;
			}

			.amount {
				font-weight: 600;
				color: #52c41a;
			}

			.join-time {
				color: #666;
				font-size: 14px;
			}

			/* 加载状态 */
			.loading-container {
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 60px;
				color: #666;
				font-size: 16px;
				gap: 10px;
			}

			.loading-container i {
				font-size: 20px;
				color: #2280FD;
			}

			/* 空状态 */
			.empty-state {
				text-align: center;
				padding: 60px 20px;
				color: #999;
			}

			.empty-state i {
				font-size: 60px;
				margin-bottom: 20px;
				color: #ddd;
			}

			.empty-text {
				font-size: 16px;
				margin-bottom: 8px;
				color: #666;
			}

			.empty-desc {
				font-size: 14px;
				color: #999;
			}

			/* 动画效果 */
			@keyframes fadeIn {
				from {
					opacity: 0;
					transform: translateY(20px);
				}

				to {
					opacity: 1;
					transform: translateY(0);
				}
			}

			.overview-card {
				animation: fadeIn 0.5s ease-out;
			}

			.overview-card:nth-child(1) {
				animation-delay: 0.1s;
			}

			.overview-card:nth-child(2) {
				animation-delay: 0.2s;
			}

			.overview-card:nth-child(3) {
				animation-delay: 0.3s;
			}
		}
	}
</style>